import React, { ButtonHTMLAttributes, FC } from "react";

import VolumeOffIcon from "../../../icons/VolumeOffIcon";
import VolumeOnIcon from "../../../icons/VolumeOnIcon";
import { usePlayerStore } from "../../../store/usePlayerStore";
import IconButton from "../IconButton";

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  isMobile: boolean;
  fillColor: string;
}

const MuteButton: FC<Props> = ({ fillColor, ...props }) => {
  const { useStoreState } = usePlayerStore();
  const isMuted = useStoreState.isMuted();
  const player = useStoreState.player();

  return (
    <IconButton {...props} onClick={() => player.setMuted(!isMuted, true)}>
      {isMuted ? (
        <VolumeOffIcon fillColor={fillColor} />
      ) : (
        <VolumeOnIcon fillColor={fillColor} />
      )}
    </IconButton>
  );
};

export default MuteButton;
